module.exports = __webpack_public_path__ + "media/components/assets/img/icons/close-392e7cea33caa42e47a8d5ca96b1f38c.svg";